import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import KuyumcuLeftSideNavbar from "./components/KuyumcuLeftSideNavbar";
// import PremiumBackground from "./components/PremiumBackground";

import { getUserId } from "../../utils/getUserId";
import axiosInstance from "../../api/axiosInstance";

import "./css/KuyumcuMainPage.css";

// Görsel yolu: src/img/usermenu(2).png
import bgImage from "./img/kuyumcuTema.png";

const KuyumcuMainPage = () => {
  const navigate = useNavigate();

  const userId = getUserId();
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  const firmaAdi =
    localStorage.getItem("firmaAdi") ||
    sessionStorage.getItem("firmaAdi") ||
    "Proset";

  const kullaniciAdi =
    localStorage.getItem("kullaniciAdi") ||
    sessionStorage.getItem("kullaniciAdi") ||
    "";

  const uyelikTip =
    localStorage.getItem("uyelikTip") ||
    sessionStorage.getItem("uyelikTip") ||
    "";

  const kuyumcuTipi =
    localStorage.getItem("kuyumcuTipi") ||
    sessionStorage.getItem("kuyumcuTipi") ||
    "";

  const [now, setNow] = useState(new Date());
  const [yetkiler, setYetkiler] = useState([]);

  /* ===========================================================
     GİRİŞ KONTROLÜ (otomatik giriş sayfası)
  =========================================================== */
  useEffect(() => {
    if (!userId || !token) {
      navigate("/login");
      return;
    }
  }, [userId, token, navigate]);

  /* ===========================================================
     BODY TEMİZLEME (sayfa ilk açılışta sidebar kapalı gelsin)
  =========================================================== */
  useEffect(() => {
    document.body.classList.remove("sidebar-open");
  }, []);

  /* ===========================================================
     SAAT / TARİH
  =========================================================== */
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const timeText = useMemo(() => {
    try {
      return now.toLocaleTimeString("tr-TR", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    } catch {
      return "";
    }
  }, [now]);

  const dateText = useMemo(() => {
    try {
      return now.toLocaleDateString("tr-TR", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "2-digit",
      });
    } catch {
      return "";
    }
  }, [now]);

  const yetkiSet = useMemo(() => new Set(yetkiler || []), [yetkiler]);

  const hasPermission = (code) => {
    if (yetkiSet.has("ALL")) return true;
    return yetkiSet.has(code);
  };

  const loadYetkiler = async () => {
    if (!userId) return;

    try {
      const resp = await axiosInstance.get("/me/yetki-kodlari", {
        params: { girisYapanUserId: userId },
      });
      setYetkiler(resp.data || []);
    } catch (e) {
      console.error("Ana sayfa yetkileri alınamadı:", e);
      setYetkiler([]);
    }
  };

  useEffect(() => {
    if (!userId) return;
    loadYetkiler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const barkodMenuGorunsun =
      uyelikTip === "SUPER_USER" ||
      (
        uyelikTip === "KUYUMCU" &&
        kuyumcuTipi === "VITRIN_KUYUMCU"
      ) ||
      (
        uyelikTip !== "KUYUMCU" &&
        hasPermission("BARKODLU_ISLEMLER_VIEW")
      );
  /* ===========================================================
     UI
  =========================================================== */
  return (
    <div className="main-container">
{/*       <PremiumBackground /> */}
      <KuyumcuLeftSideNavbar />

      <div className="content">
        <div
          className="kuyumcu-home-hero"
          style={{ "--kuyumcu-bg": `url(${bgImage})` }}
        >
          <div className="kuyumcu-home-overlay" />

          <div className="kuyumcu-home-shell">
{/*             <PremiumBackground /> */}
            <div className="kuyumcu-home-card">
              <div className="kuyumcu-home-brand">
                <div className="kuyumcu-home-brandDot" />
                <div className="kuyumcu-home-brandText">
                  <div className="kuyumcu-home-brandTitle">{firmaAdi}</div>
                  <div className="kuyumcu-home-brandSub">
                    Kuyumcu Programı
                  </div>
                </div>
              </div>

              <div className="kuyumcu-home-welcome">
                <div className="kuyumcu-home-h1">Hoş geldiniz</div>
                <div className="kuyumcu-home-h2">
                  {kullaniciAdi ? (
                    <>
                      <span className="kuyumcu-home-strong">{kullaniciAdi}</span>
                      {uyelikTip ? (
                        <span className="kuyumcu-home-badge">{uyelikTip}</span>
                      ) : null}
                    </>
                  ) : (
                    <span className="kuyumcu-home-strong">Kullanıcı</span>
                  )}
                </div>

                <div className="kuyumcu-home-meta">
                  <div className="kuyumcu-home-metaItem">
                    <span className="kuyumcu-home-metaLabel">Tarih</span>
                    <span className="kuyumcu-home-metaValue">{dateText}</span>
                  </div>
                  <div className="kuyumcu-home-metaItem">
                    <span className="kuyumcu-home-metaLabel">Saat</span>
                    <span className="kuyumcu-home-metaValue">{timeText}</span>
                  </div>
                </div>

                <div className="kuyumcu-home-divider" />

                <div className="kuyumcu-home-desc">
                  İşlem, stok ve hesap yönetimine hızlıca devam edebilirsiniz.
                  Aşağıdaki kısayollardan dilediğinizi açın.
                </div>
              </div>

              <div className="kuyumcu-home-actions">
                {uyelikTip === "SUPER_USER" && (
                  <button
                    className="kuyumcu-home-btn"
                    onClick={() => navigate("/kuyumcuYonetimPanel")}
                  >
                    Yönetim Paneli
                  </button>
                )}

                {barkodMenuGorunsun && (
                  <button
                    className="kuyumcu-home-btn"
                    onClick={() => navigate("/kuyumcuBarkodluIslemler")}
                  >
                    Barkodlu İşlemler
                  </button>
                )}

                <button
                  className="kuyumcu-home-btn primary"
                  onClick={() => navigate("/kuyumcuHesaplar")}
                >
                  Hesaplar
                </button>

                <button
                  className="kuyumcu-home-btn"
                  onClick={() => navigate("/kuyumcuKasa")}
                >
                  Kasa
                </button>

                <button
                  className="kuyumcu-home-btn"
                  onClick={() => navigate("/kuyumcuStok")}
                >
                  Stok
                </button>

                <button
                  className="kuyumcu-home-btn"
                  onClick={() => navigate("/kuyumcuCanta")}
                >
                  Çanta
                </button>

                <button
                  className="kuyumcu-home-btn"
                  onClick={() => navigate("/kuyumcuRaporlar")}
                >
                  Raporlar
                </button>

                <button
                  className="kuyumcu-home-btn"
                  onClick={() => navigate("/kuyumcuIslemGecmisi")}
                >
                  İşlem Geçmişi
                </button>

                <button
                  className="kuyumcu-home-btn"
                  onClick={() => navigate("/kuyumcuParametreler")}
                >
                  Parametreler
                </button>

                <button
                  className="kuyumcu-home-btn"
                  onClick={() => navigate("/kuyumcuKullanicilar")}
                >
                  Kullanıcılar
                </button>

                <button
                  className="kuyumcu-home-btn"
                  onClick={() => navigate("/kuyumcuProfil")}
                >
                  Profil
                </button>

                <button
                  className="kuyumcu-home-btn danger"
                  onClick={() => {
                    localStorage.removeItem("token");
                    localStorage.removeItem("userId");
                    localStorage.removeItem("uyelikTip");
                    localStorage.removeItem("kuyumcuTipi");

                    sessionStorage.removeItem("token");
                    sessionStorage.removeItem("userId");
                    sessionStorage.removeItem("uyelikTip");
                    sessionStorage.removeItem("kuyumcuTipi");

                    navigate("/");
                  }}
                >
                  Çıkış Yap
                </button>
              </div>

              <div className="kuyumcu-home-footnote">
                Güvenli oturum aktif.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KuyumcuMainPage;